import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-5" }
const _hoisted_2 = { class: "flex xs:flex-col border-t border-b border-t-white border-b-white gap-5 text-base" }
const _hoisted_3 = { class: "flex flex-col gap-5 w-full" }
const _hoisted_4 = { class: "rounded-xl bg-gray-100 shadow-sm p-5 text-center flex flex-col items-center" }
const _hoisted_5 = { class: "flex flex-col text-left" }
const _hoisted_6 = { class: "flex flex-col text-left" }
const _hoisted_7 = { class: "flex icon-text text-left justify-start items-center" }
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { class: "flex icon-text text-left justify-start items-center" }
const _hoisted_10 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("img", {
      src: "https://resource.pafcpic.net/assets/papsi/papsi_logo.png",
      class: "w-1/4 mb-2 pt-6"
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-2xl lg:text-3xl font-bold text-theme-primary mb-5 text-left" }, "Contact Us", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "w-full flex items-center justify-center text-center" }, [
        _createElementVNode("img", {
          src: "https://resource.pafcpic.net/assets/pia/images/elements/papsi-kara.png",
          class: "w-1/2 lg:w-full"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "rounded-xl bg-gray-100 shadow-sm p-5 w-full text-center flex flex-col items-center" }, [
          _createElementVNode("span", { class: "text-xl font-bold mb-1 text-gray-500" }, "Website"),
          _createElementVNode("div", { class: "flex flex-col text-center" }, [
            _createElementVNode("a", {
              href: "https://pafcpic.ph/",
              target: "_blank",
              rel: "noopener",
              class: "hover:underline hover:text-theme-primary"
            }, " https://pafcpic.ph/ ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-full mb-1" }, [
            _createElementVNode("span", { class: "text-xl font-bold mb-3 text-gray-500" }, "Social Media")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Icon, {
                  source: "images/Facebook_f_logo.png",
                  class: "pr-1",
                  width: 20
                }),
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    href: "https://www.facebook.com/pafcpic",
                    target: "_blank",
                    rel: "noreferrer",
                    class: "hover:underline hover:text-theme-primary",
                    textContent: _toDisplayString(_ctx.lang('facebook.text'))
                  }, null, 8, _hoisted_8)
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Icon, {
                  source: "images/Instagram_logo.png",
                  class: "pr-1",
                  width: 20
                }),
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    href: "https://www.instagram.com/pafcpicofficial/ ",
                    target: "_blank",
                    rel: "noreferrer",
                    textContent: _toDisplayString(_ctx.lang('instagram.text')),
                    class: "hover:underline hover:text-theme-primary"
                  }, null, 8, _hoisted_10)
                ])
              ])
            ])
          ])
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "rounded-xl bg-gray-100 shadow-sm p-5 w-full text-center flex flex-col items-center" }, [
          _createElementVNode("span", { class: "text-xl font-bold mb-1 text-gray-500" }, "Customer Support"),
          _createElementVNode("div", { class: "flex flex-col text-left" }, [
            _createElementVNode("span", null, "(+63) 998-588-1969"),
            _createElementVNode("span", null, "customer@pafcpic365.com")
          ])
        ], -1))
      ])
    ])
  ]))
}